var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRipple17S200Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-ripple",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 38.8235,
    fill: "none",
    "ng-attr-stroke": "{{config.c1}}",
    "ng-attr-stroke-width": "{{config.width}}",
    stroke: "#912623",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    calcMode: "spline",
    values: "0;40",
    keyTimes: "0;1",
    dur: 1.7,
    keySplines: "0 0.2 0.8 1",
    begin: "-0.85s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    values: "1;0",
    keyTimes: "0;1",
    dur: 1.7,
    keySplines: "0.2 0 0.8 1",
    begin: "-0.85s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 22.4209,
    fill: "none",
    "ng-attr-stroke": "{{config.c2}}",
    "ng-attr-stroke-width": "{{config.width}}",
    stroke: "#f0f5f6",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    calcMode: "spline",
    values: "0;40",
    keyTimes: "0;1",
    dur: 1.7,
    keySplines: "0 0.2 0.8 1",
    begin: "0s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    values: "1;0",
    keyTimes: "0;1",
    dur: 1.7,
    keySplines: "0.2 0 0.8 1",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipple17S200Px);
export default __webpack_public_path__ + "static/media/Ripple-1.7s-200px.ec9bf62a9f4986549a8c52fd98c15bef.svg";
export { ForwardRef as ReactComponent };